import { render, staticRenderFns } from "./AreaReferences.vue?vue&type=template&id=b36e059c&"
import script from "./AreaReferences.vue?vue&type=script&lang=js&"
export * from "./AreaReferences.vue?vue&type=script&lang=js&"
import style0 from "./AreaReferences.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports